import { Box, TextField } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { useForm } from "hooks/useForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { editConditionCustomer } from "redux/actions/customers/customersAction";
import CloseIcon from "@material-ui/icons/Close";

export const EditConditionForm = ({ original, onClose }) => {
  const dispatch = useDispatch();
  const { conditions } = useSelector(
    ({ conditionsReducer }) => conditionsReducer
  );

  const { id } = useParams();
  const {
    inputValues,
    handleInputOnChange,
    onChangeNumber,
    handleNewValues,
    runValidatesExe,
    fieldErrors,
  } = useForm(
    {
      quantity: original.quantity,
      description: original.description,
      block: true,
    },
    { quantity: { required: true } }
  );
  const { quantity, description, block } = inputValues;

  const edit = () => {
    let label = "";
    const condition = conditions.find(
      (condi) => condi.id === original.idComercialCondition
    );
    if (condition.metricUnit === "$") {
      label = `$ ${quantity}`;
    } else if (
      condition?.metricUnit === "N/A" &&
      condition?.metricUnit === "SI" &&
      condition?.metricUnit === "NO"
    ) {
      label = quantity;
    } else {
      label = `${quantity} ${condition.metricUnit}`;
    }
    dispatch(
      editConditionCustomer(id, original.id, { quantity: label, description })
    );
    onClose();
  };
  const handleEdit = () => runValidatesExe([], edit);

  useEffect(() => {
    original?.quantity !== "N/A" &&
      original?.quantity !== "SI" &&
      original?.quantity !== "NO" &&
      handleNewValues({ block: false });
  }, []);
  
  return (
    <Box style={{ display: "grid", gap: 12 }}>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        label="Cantidad"
        name="quantity"
        value={quantity}
        onChange={onChangeNumber}
        disabled={block}
        InputProps={{
          endAdornment: !block && (
            <RegularButton
              justIcon
              round
              color="transparent"
              onClick={() => handleNewValues({ quantity: "" })}
            >
              <CloseIcon />
            </RegularButton>
          ),
          inputProps: { right: "1" },
        }}
        error={fieldErrors.quantity}
        helperText={fieldErrors.quantity}
      />
      <TextField
        minRows={3}
        multiline
        fullWidth
        variant="outlined"
        size="small"
        label="Detalles"
        name="description"
        value={description}
        onChange={handleInputOnChange}
      />
      <Box
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        <RegularButton size="sm" tooltip="" color="danger" onClick={onClose}>
          Cancelar
        </RegularButton>
        <RegularButton size="sm" tooltip="" color="info" onClick={handleEdit}>
          Guardar
        </RegularButton>
      </Box>
    </Box>
  );
};
